// Heatmap Historique — agrégation spatiale BORNÉE côté frontend (aucune requête backend, aucune au zoom).
// 3 modes : activité (densité de passage normalisée), temps passé (pondéré durée), arrêts (durée d'arrêt).
const GRID = 0.00045;              // ~50 m à la latitude NC
const CAP = 15000;                 // nb max de cellules injectées dans le plugin (borne perf)
const _p = (ts) => (typeof ts === "string" ? Date.parse(ts) : ts);
const cellKey = (lat, lon) => `${Math.round(lat / GRID)}|${Math.round(lon / GRID)}`;
const cellCenter = (k) => { const [a, b] = k.split("|").map(Number); return [a * GRID, b * GRID]; };

export const HEAT_MODES = { activity: "Activité", dwell: "Temps passé", stops: "Arrêts" };

// trips = trajets déjà chargés via /fleet-trips (points sous-échantillonnés + events serveur).
export function buildHeat(trips, mode) {
  const cells = new Map();
  const add = (lat, lon, w) => {
    if (lat == null || lon == null || !(w > 0)) return;
    const k = cellKey(lat, lon); cells.set(k, (cells.get(k) || 0) + w);
  };
  (trips || []).forEach((t) => {
    const pts = t.points || [];
    if (mode === "activity") {
      // 1 point par cellule PAR TRAJET -> indépendant de la fréquence d'émission du boîtier (pas de biais device bavard)
      const seen = new Set();
      pts.forEach((p) => { const k = cellKey(p.lat, p.lon); if (!seen.has(k)) { seen.add(k); add(p.lat, p.lon, 1); } });
    } else if (mode === "dwell") {
      // temps passé : durée entre points consécutifs (borne anti-trou GPS à 1 h)
      for (let i = 0; i < pts.length - 1; i++) {
        const dt = Math.min(3600, Math.max(0, (_p(pts[i + 1].timestamp) - _p(pts[i].timestamp)) / 1000));
        add(pts[i].lat, pts[i].lon, dt);
      }
    } else if (mode === "stops") {
      // arrêts détectés (stop/idle) pondérés par leur durée -> sites clients, dépôts, chantiers
      (t.events || []).forEach((e) => { if (e.type === "stop" || e.type === "idle") add(e.lat, e.lon, Math.max(1, e.duration_min || 1)); });
    }
  });
  let max = 0; cells.forEach((w) => { if (w > max) max = w; });
  if (max <= 0) return [];
  let arr = [];
  cells.forEach((w, k) => { const [lat, lon] = cellCenter(k); arr.push([lat, lon, w]); });
  if (arr.length > CAP) arr.sort((a, b) => b[2] - a[2]).splice(CAP); // garde les CAP cellules les plus fortes
  // gamma 0.6 : compresse la dynamique pour garder les zones moyennes lisibles
  return arr.map(([lat, lon, w]) => [lat, lon, Math.pow(Math.min(1, w / max), 0.6)]);
}
